import axios from 'axios';
import { isEmpty } from 'lodash';
import * as consumptionService from '../../../services/consumption';

const getConsumption = async ({ commit }) => {
  try {
    const response = await axios.get('consumption');
    const payload = response.data;

    commit('GET_CONSUMPTION', payload);
    return payload;
  } catch (error) {
    throw error;
  }
};

const fetchConsumptionPeriods = async ({ commit, rootGetters }, url) => {
  try {
    const response = await consumptionService.fetchConsumptionPeriods(url);

    if (isEmpty(response)) commit('SET_CONSUMPTION_PERIODS', []);
    // TOGGLE_MIDAS_CLIENT_INTEGRATION_ENABLED
    // TODO: Remove isToggleEnabled and midasEnabled
    const isToggleEnabled = rootGetters['featureFlags/isToggleEnabled'];
    const midasEnabled = isToggleEnabled('TOGGLE_MIDAS_CLIENT_INTEGRATION_ENABLED');

    // TOGGLE_MIDAS_CLIENT_INTEGRATION_ENABLED
    // TODO: Keep the logic for midasEnabled (if content)
    if (midasEnabled) {
      commit('SET_CONSUMPTION_PERIODS', response.invoices);
    } else {
      commit('SET_CONSUMPTION_PERIODS', response.periods);
    }

    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  getConsumption,
  fetchConsumptionPeriods,
};
